/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingimages1Inputs */

const en_listingimages1 = /** @type {(inputs: Listingimages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Images`)
};

const de_listingimages1 = /** @type {(inputs: Listingimages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilderliste`)
};

/**
* | output |
* | --- |
* | "Listing Images" |
*
* @param {Listingimages1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingimages1 = /** @type {((inputs?: Listingimages1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingimages1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingimages1(inputs)
	return de_listingimages1(inputs)
});
export { listingimages1 as "listingImages" }